import { render, staticRenderFns } from "./courseCellPlaceholder.vue?vue&type=template&id=a97fad38&scoped=true"
import script from "./courseCellPlaceholder.vue?vue&type=script&lang=ts"
export * from "./courseCellPlaceholder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97fad38",
  null
  
)

export default component.exports